// extracted by mini-css-extract-plugin
export default {"wrapper":"lIPuF","inputAndButtonContainer":"_HP0n","copyButton":"cGU9A","linkInputField":"Mw0zb","linkIcon":"SDEwL","inputContainer":"xKHT2","inputContainerHidden":"ReCyJ"};